import axios from 'axios';

import { REST_API_PATH } from './constants';

export const http = axios.create({
  baseURL: REST_API_PATH,
  withCredentials: true,
});

http.interceptors.response.use(
  (response) => response,
  (error) => {
    const shouldRedirect = !['/', '/logout'].includes(window.location.pathname);

    if (error.response.status === 401 && shouldRedirect) {
      window.location.href = '/logout';
    }

    return Promise.reject(error);
  },
);
